/**
 * Stub para google-auth-library - solo para Node.js
 * Este módulo se usa en @boosting/ai para autenticación con Google Cloud
 * pero no debe usarse en el frontend - la autenticación se hace via Cloud Functions
 */
export class GoogleAuth {
  constructor() {
    throw new Error('google-auth-library no está disponible en el navegador. Usa Cloud Functions para autenticación con Google Cloud.');
  }
}

export class OAuth2Client {
  constructor() {
    throw new Error('OAuth2Client no está disponible en el navegador.');
  }
}

export default { GoogleAuth, OAuth2Client };
